<template>
  <div class="remoteControl">
    <div class="unit-con">
      <el-select
        v-model="deviceId"
        placeholder="请选择设备"
        @change="selectDevice"
        :popper-append-to-body="false"
      >
        <el-option
          v-for="item in deviceList"
          :key="item.id"
          :label="item.deviceName"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div class="container">
      <div class="container-left">
        <section class="container-left-top">
          <header class="info_header">
            <ul class="info_tab">
              <li
                v-for="(item, index) in videoTab"
                :key="index"
                :class="{ active: currentVideoTab == index }"
              >
                {{ item }}
              </li>
            </ul>
          </header>
          <section class="video-content">
            <section class="video-info">
              <div class="video-item">
                <videoPlayer
                  ref="videoPlayerRef"
                  :videoUrl="videoUrl"
                  :videoToken="videoToken"
                  v-if="videoUrl"
                ></videoPlayer>
                <span v-else>暂无视频</span>
              </div>
              <div class="desc">
                <span>设备名称：{{ videoName }}</span>
              </div>
            </section>
            <section class="other-info">
              <span class="refresh_btn" @click="getVideoInfo">
                <img src="./img/refresh.png" alt="refresh" />
                <span>刷新</span>
              </span>
              <section class="controller">
                <header class="common_header">
                  <span>控制器远控</span>
                </header>
                <controller
                  :deviceStatus="deviceStatus"
                  :controlStatus="controlStatus"
                  @changeStatus="handleChangeStatus"
                ></controller>
              </section>
            </section>
          </section>
        </section>
        <section class="container-left-bottom">
          <header class="common_header" style="width: 100%;">
            <span>部件远控</span>
            <div class="more" @click="checkMore('1')">
              <span>更多</span>
              <img src="./img/more.png" alt="more" />
            </div>
          </header>
          <section class="part-control">
            <div class="scrollWrap">
              <ul>
                <li v-for="(o, index) in partList" :key="index">
                  <PartItem :item="o" @show-modal="handleShowModal" />
                </li>
              </ul>
            </div>
          </section>
        </section>
      </div>
      <div class="container-right">
        <section class="alarm-info">
          <header class="common_header">
            <span>总线盘</span>
            <div class="more" @click="checkMore('0')">
              <span>更多</span>
              <img src="./img/more.png" alt="more" />
            </div>
          </header>
          <ul class="total-pannel">
            <li v-for="(item, index) in totalPartsList" :key="index">
              <PartItem :item="item" @show-modal="handleShowModal" />
            </li>
          </ul>
        </section>
        <section class="alarm-list">
          <header class="common_header">
            <span>操作记录</span>
            <div
              class="more"
              @click="
                $router.push({
                  name: 'actionRecord'
                })
              "
            >
              <span>更多</span>
              <img src="./img/more.png" alt="more" />
            </div>
          </header>
          <div class="alarm-table">
            <el-table :data="tableData" style="width: 100%" :show-header="false">
              <el-table-column
                prop="create_time"
                name="操作时间"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="deviceName" name="设备名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.actionType == 0">{{ scope.row.deviceName }}</span>
                  <span v-else>{{ scope.row.devicePartsName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="actionName"
                name="描述"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </div>
        </section>
      </div>
    </div>

    <!-- 全局弹窗 -->
    <CustomModal
      :visible.sync="showGlobalModal"
      :message="modalMessage"
      :title="modalTitle"
      @confirm="handleModalConfirm"
      @cancel="handleModalCancel"
    />
    <partsModal :deviceId="deviceId" :partsModel="partsModel" v-model="showPartsModal"></partsModal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showModal: false,
        modalMessage: '确定调整为允许吗?',
        // 全局弹窗数据
        showGlobalModal: false,
        modalTitle: '',
        pendingAction: null,
        tableData: [],
        partList: [],
        totalPartsList: [],
        deviceId: 0,
        deviceList: [],
        deviceName: '',
        deviceStatus: '',
        controlStatus: '',
        videoUrl: '',
        videoToken: '',
        videoName: '',
        currentVideoTab: 0,
        videoTab: ['主机视频'],
        showPartsModal: false,
        partsModel: '0'
      }
    },
    components: {
      CustomModal: () => import('./components/customModal'),
      controller: () => import('./components/controller'),
      PartItem: () => import('./components/PartItem'),
      mp: () => import('public/mapDialog/index.vue'),
      videoPlayer: () => import('./components/video'),
      partsModal: () => import('./components/partsModal')
    },
    mounted() {
      this.getRecordData()
      this.getDeviceList()
    },
    methods: {
      getDeviceList() {
        this.$axiosget('operation/third/sanjiang/getSanJiangDeviceList').then(res => {
          if (res.data.status == 10000) {
            this.deviceList = res.data.data
            if (res.data.data.length > 0) {
              this.deviceId = res.data.data[0].id || ''
              this.deviceName = res.data.data[0].deviceName || ''
              this.getDeviceControlInfo()
              this.getVideoInfo()
            } else {
              this.deviceId = ''
              this.deviceName = ''
            }
          }
        })
      },
      selectDevice(id) {
        this.deviceId = id
        this.deviceName = this.deviceList.find(item => item.id == id)
          ? this.deviceList.find(item => item.id == id).deviceName
          : ''
        this.currentVideoTab = 0
        this.getDeviceControlInfo()
        this.getVideoInfo()
      },
      // 全局弹窗处理方法
      handleShowModal(data) {
        this.showGlobalModal = true
        this.modalMessage = data.message
        this.modalTitle = data.title
        this.pendingAction = {
          status: data.status,
          item: data.item
        }
      },
      handleModalConfirm() {
        this.showGlobalModal = false
        if (this.pendingAction) {
          if (this.pendingAction.status === 'start') {
            this.handlePartStart(this.pendingAction.item)
          } else {
            this.handlePartStop(this.pendingAction.item)
          }
          this.pendingAction = null
        }
      },
      handleModalCancel() {
        this.showGlobalModal = false
        this.pendingAction = null
      },
      getVideoInfo() {
        this.videoUrl = ''
        this.videoName = ''
        this.$axiosget(`operation/third/sanjiang/queryDeviceControlInfo/${this.deviceId}`).then(
          res => {
            if (res.data.status == 10000) {
              if (res.data.data.videoUrl) {
                let videoInfo = res.data.data.videoUrl.find(item => item.mark == 'url1')
                this.videoToken = res.data.data.videoToken
                this.videoUrl = videoInfo.value || ''
                this.videoName = videoInfo.name || ''
              } else {
                this.videoUrl = ''
                this.videoName = ''
              }
            }
          }
        )
      },
      getDeviceControlInfo() {
        this.$axiosget(`operation/third/sanjiang/queryDeviceControlInfo/${this.deviceId}`).then(
          res => {
            if (res.data.status == 10000) {
              this.deviceStatus = res.data.data.deviceStatus ? res.data.data.deviceStatus : ''
              this.controlStatus = res.data.data.controlStatus ? res.data.data.controlStatus : ''
              this.partList =
                res.data.data.deviceParts.length > 0
                  ? res.data.data.deviceParts.filter(item => item.partsModel === '1').length > 9
                    ? res.data.data.deviceParts.filter(item => item.partsModel === '1').slice(0, 9)
                    : res.data.data.deviceParts.filter(item => item.partsModel === '1')
                  : []
              this.totalPartsList =
                res.data.data.deviceParts.length > 0
                  ? res.data.data.deviceParts.filter(item => item.partsModel === '0').length > 15
                    ? res.data.data.deviceParts.filter(item => item.partsModel === '0').slice(0, 15)
                    : res.data.data.deviceParts.filter(item => item.partsModel === '0')
                  : []
            }
          }
        )
      },
      handleChangeStatus(action) {
        this.$axiospost('operation/device/action/record/issue/control', {
          deviceId: this.deviceId,
          command: action
        }).then(res => {
          if (res.data.status == 10000) {
            this.$message.success('操作成功')
            this.getDeviceControlInfo()
            this.getRecordData()
          }
        })
      },
      handlePartStop(item) {
        this.$axiospost('operation/device/action/record/issue/control', {
          deviceId: item.deviceId,
          devicePartsId: item.id,
          command: 5
        }).then(res => {
          if (res.data.status == 10000) {
            this.$message.success('操作成功')
            this.getDeviceControlInfo()
            this.getRecordData()
          }
        })
      },
      handlePartStart(item) {
        this.$axiospost('operation/device/action/record/issue/control', {
          deviceId: item.deviceId,
          devicePartsId: item.id,
          command: 4
        }).then(res => {
          if (res.data.status == 10000) {
            this.$message.success('操作成功')
            this.getDeviceControlInfo()
            this.getRecordData()
          }
        })
      },
      checkMore(partsModel) {
        this.partsModel = partsModel
        this.showPartsModal = true
      },
      getRecordData() {
        this.$axiosget('operation/device/action/record/getTodayActionRecord').then(res => {
          if (res.data.status == 10000) {
            this.tableData = res.data.data
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .remoteControl {
    padding: 1vh 0.14rem 0;
    height: 100%;
    background: #001643;

    .unit-con {
      width: 1.73rem;
      height: 2.97vh;
      /deep/ .el-select {
        height: 100%;
        background-color: #001643;
        border-radius: 0.06rem;
        display: flex;
        align-items: center;
        border: 1px solid #2356a9;
        color: #0ed4ff;

        .el-input__inner {
          height: 100%;
          background: transparent;
          border: none;
          color: #0ed4ff;
        }

        .el-input__icon {
          height: 100%;
          line-height: 2vh;
        }
      }

      /deep/ .el-select-dropdown {
        background: #0e397f;
        color: #adcde9;

        .el-select-dropdown__item:hover,
        .el-select-dropdown__item.hover {
          background: #12479d;
          color: #53cdff;
        }
      }
    }

    .container {
      margin-top: 0.65vh;
      height: calc(100% - 4.91vh);
      display: flex;

      .common_header {
        background-image: url('./img/common_header.png');
        background-size: 100% 100%;
        height: 4.36vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 0.24rem;
        padding-right: 0.17rem;

        span {
          font-family: MicrosoftYaHei;
          font-size: 1.67vh;
          font-weight: bold;
          font-style: italic;
          color: #fff;
        }

        .more {
          cursor: pointer;
          span {
            font-family: FZLTZHK--GBK1-0;
            font-size: 1.3vh;
            font-weight: normal;
            color: #25b0ff;
            text-shadow: 0 0 4px rgba(255, 255, 255, 0.6), 0 0 4px rgba(4, 51, 137, 0.53);
          }
        }
      }

      .container-left {
        flex: 1;
        height: 100%;

        &-top {
          height: 62.24vh;
          margin-bottom: 2.13vh;
          background-color: #0b255e;
          border-radius: 0.1rem;
          padding: 1.39vh 0.14rem 2.41vh 0.24rem;

          .info_header {
            height: 4.36vh;
            background-image: url('./img/video_header.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 0.17rem;

            span {
              // max-width: 2.8rem;
              // display: inline-block;
              // overflow: hidden;
              // white-space: nowrap;
              // text-overflow: ellipsis;
              font-family: 'MicrosoftYaHei';
              font-size: 1.67vh;
              font-weight: bold;
              color: #fff;
            }

            ul {
              padding-left: 0.11rem;
              display: flex;
              align-items: center;

              li {
                padding: 0 0.11rem;
                font-family: 'MicrosoftYaHei';
                font-size: 1.67vh;
                font-weight: bold;
                font-style: italic;
                color: rgba(255, 255, 255, 0.8);
                cursor: pointer;

                &.active {
                  color: #fff;
                }
              }
            }
          }

          .video-content {
            margin-top: 1.02vh;
            height: calc(100% - 4.36vh - 1.39vh);
            display: flex;

            .video-info {
              flex: 1;

              .video-item {
                height: calc(100% - 4.08vh);
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: HiraginoSansGB-W3;
                font-size: 1.3vh;
                color: rgba(255, 255, 255, 0.8);
              }

              .desc {
                height: 4.08vh;
                background-color: rgba(28, 66, 142, 0.6);
                border-radius: 0 0 0.03rem 0.03rem;
                padding: 0 0.12rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: HiraginoSansGB-W3;
                font-size: 1.3vh;
                color: #d8e5ff;
              }
            }

            .other-info {
              margin-left: 0.1rem;
              width: 1.18rem;

              .refresh_btn {
                width: 100%;
                height: 3.62vh;
                background-color: #198aff;
                border-radius: 0.08rem;
                margin-top: 1.2vh;
                display: inline-flex;
                justify-content: center;
                align-items: center;

                img {
                  width: 0.18rem;
                  height: auto;
                }

                span {
                  margin-left: 0.03rem;
                  font-family: HiraginoSansGB-W3;
                  font-size: 1.48vh;
                  color: #fff;
                }
              }

              .controller {
                width: 100%;
                margin-top: 1.02vh;
                height: calc(100% - 4.82vh - 1.02vh);

                .common_header {
                  width: 100%;
                  height: 3.8vh;
                  background-image: url('./img/control_header.png');
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                  padding-left: 0.2rem;
                  font-family: MicrosoftYaHei;
                  font-weight: bold;
                  font-size: 1.67vh;
                  font-style: italic;
                  color: #fff;

                  span {
                    font-size: 1.6vh;
                  }
                }
              }
            }
          }
        }

        .container-left-bottom {
          height: calc(100% - 62.24vh - 2.13vh);
          background-color: #0b255e;
          border-radius: 0.1rem;
          padding: 1.2vh 0.23rem 0 0.27rem;

          header {
            background-image: url('./img/headers.png');
          }

          .part-control {
            height: calc(100% - 4.36vh);
            overflow: hidden;
            padding-top: 1.21vh;

            .scrollWrap {
              display: flex;
              height: 12.71vh;

              & > ul {
                width: 100%;
                height: 100%;
                flex-shrink: 0;
                display: flex;
                align-items: center;

                & > li {
                  width: calc((100% - 1.68rem) / 9);
                  margin-right: 0.21rem;

                  &:last-child {
                    margin-right: 0;
                  }
                }
              }
            }

            .pages {
              width: 100%;
              margin-top: 1.3vh;

              ul {
                display: flex;
                justify-content: center;
              }

              li {
                width: 0.2rem;
                height: 0.28vh;
                background: #254485;
                margin-right: 0.1rem;
                cursor: pointer;
              }

              .active {
                background: #328eea;
              }
            }
          }
        }
      }

      .container-right {
        width: 6rem;
        height: 100%;
        background-image: url('./img/left_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 0.1rem;
        margin-left: 0.24rem;

        .alarm-info {
          height: calc(100% - 34.79vh);
          padding: 1.2vh 0.23rem 0;

          .total-pannel {
            height: calc(100% - 4.36vh - 1.2vh);
            margin-top: 2vh;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;

            & > li {
              width: calc((100% - 0.7rem) / 5);
              margin-right: 0.14rem;
              margin-bottom: 1.85vh;

              &:nth-child(5n) {
                margin-right: 0;
              }
            }
          }
        }

        .alarm-list {
          height: 34.79vh;
          background-image: url('./img/table_bg.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          border-radius: 0.1rem;
          padding: 1.2vh 0.23rem 0.64vh;

          .alarm-table {
            margin-top: 1.3vh;
            height: calc(100% - 1.3vh - 4.36vh);
            overflow: auto;

            /deep/ .el-table {
              height: 100%;
              background: rgba(4, 51, 137, 0.53);
              tr {
                height: 32px;
                background: #103076;

                td {
                  padding: 0;
                  font-family: MicrosoftYaHei;
                  font-size: 12px;
                  color: #adc7ff;
                  border-bottom: 7px solid #062055;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/remoteControl/index.vue